import React, {useContext} from 'react';
import {TabbedOverviewPage, ScoreStructureSection, ReadinessSolutionScoresSection} from '../components/OverviewSections.comp';
import {AuthContext} from '../../../context/auth';
import {getPlanStage} from '../../../utils/productAccess';

const AboutScoresPage = () => {
    const {authUser} = useContext(AuthContext);
    const stage = getPlanStage(authUser);

    // "COS Readiness Solution Scores" = P1 + LC; "COS Children Assessment Scores"
    // = every plan. With one tab, TabbedOverviewPage hides the tab bar.
    const tabs = [
        ...(stage === 'P1' || stage === 'LC' ? [{label: 'COS Readiness Solution Scores', content: <ReadinessSolutionScoresSection/>}] : []),
        {label: 'COS Children Assessment Scores', content: <ScoreStructureSection/>},
    ];

    return <TabbedOverviewPage tabs={tabs}/>;
};

export default AboutScoresPage;
